
<template>
    <el-card shadow="never" class="l-main-card">
        <div class="l-table-toolbar" style="text-align: center;">
            <el-form :model="search_data" ref="form" label-position="left" >

                <div class="input-with-select" style="margin-right:20px;padding: 10px;">
                    <el-input placeholder="设备IP" style="width: 300px;" v-model="search_data.DisplayId" clearable>
                    </el-input>
                </div>

                <div class="input-with-select" style="margin-right:20px;padding: 10px;">
                    <el-input placeholder="注册IP" style="width: 300px;" v-model="search_data.RegIp" clearable>
                    </el-input>
                </div>

                <div class="input-with-select" style="margin-right:20px;padding: 10px;">
                    <el-input placeholder="注册设备号" style="width: 300px;" v-model="search_data.RegMachineCode" clearable>
                    </el-input>
                </div>

                <div class="input-with-select" style="margin-right:20px;padding: 10px;">
                    <el-input placeholder="登录IP" style="width: 300px;" v-model="search_data.CurrIP" clearable>
                    </el-input>
                </div>

                <div class="input-with-select" style="margin-right:20px;padding: 10px;">
                    <el-input placeholder="登录设备号" style="width: 300px;" v-model="search_data.CurrMachineCode" clearable>
                    </el-input>
                </div>

                <el-button style="margin-left:10px" type="primary" @click="onSearch" icon="el-icon-search">查询
                </el-button>

                <el-button type="default" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
            </el-form>
        </div>
        <l-table :data="data" v-loading="loading" row-key="id">
            <!-- <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column> -->
            <el-table-column prop="Name" label="用户ID" min-width="160" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="DisplayId" label="用户名称" min-width="180" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="CreateTime" label="注册时间" min-width="200" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="RegMachineCode" label="注册设备号" min-width="260" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="RegIP" label="注册IP" min-width="160" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="CurrMachineCode" label="登录设备号" min-width="260" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="CurrIP" label="登录IP" min-width="160" show-overflow-tooltip> </el-table-column>

        <!-- <el-table-column fixed="right" label="操作" width="130" align="center">
          <template slot-scope="{ row }">
            <l-auth-text-button type="primary" auth="logs_info_btn" @click="showInfo(row)"><i
                class="el-icon-warning-outline"></i>详情</l-auth-text-button>
          </template>
            </el-table-column> -->
        </l-table>

        <!--分页-->
        <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
            :current-page.sync="page"></l-page>


    </el-card>
</template>
  
<script>
import Vue from "vue";
export default {
    name: "l-double",
    data() {
        return {
            data: [],
            count: 0,
            page: 1,
            page_size: Vue.$_config.page.page_size,
            loading: false,
            //搜索
            search_visible: false,
            site_list: [],
            search_data: {
                RegMachineCode: "",
                RegIp: "",
                CurrIP:"",
                CurrMachineCode:"",
                DisplayId:""
            },
            rel_search_data: {},
        };
    },
    // mounted() {
    //   this.getList();
    // },

    methods: {
        //获取数据
        getList() {
            this.loading = true;
            this.$_invoke("appUserDouble_getList", {
                page: this.page,
                page_size: this.page_size,
                ...this.rel_search_data,
            })
                .then((ret) => {
                    console.log(ret.data);
                    this.data = ret.data;
                    this.count = ret.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        //点击搜索按钮
        onSearch() {
            this.page = 1;
            this.rel_search_data = this.search_data;
            this.getList();
        },

        //点击重置搜索框
        onReset() {
            this.$refs.search_form.resetFields();
            this.rel_search_data = {};
        },

        //清除搜索数据
        clearSearch() {
            this.search_data.RegMachineCode = "";
            this.search_data.RegIp = "";
            this.getList();
        },
    },
};
</script>
  